<template>
  <div v-if="priceList">
    <modalWindow v-model="show" @ok="createSubmit()" @cancel="cancel()" @closed="onClose()" title="Editácia cenníku" okText="Uložiť" cancelText="Zrušiť">
      <form data-vv-scope="createForm">
        <div class="row">
          <div class="col-sm-6">
            <select-field field-id="createForm.customer"
                          label="Zákazník"
                          :options="customers"
                          v-model="priceList.customer"
                          scope="createForm"
                          validation="required"></select-field>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <date-field v-model="priceList.validFrom"
                        field-id="createForm.validFrom"
                        label="Platnosť od"
                        scope="createForm"
                        :showArrows="false"></date-field>
          </div>
          <div class="col-sm-6">
            <date-field v-model="priceList.validTo"
                        field-id="createForm.validTo"
                        label="Platnosť do"
                        scope="createForm"
                        :showArrows="false"></date-field>
          </div>
        </div>
      </form>

        <form data-vv-scope="addItemForm">
          <div class="row">
            <div class="col-sm-12">
              <hr />
              <h4>Položky</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <select-field field-id="product"
                            label="Produkt"
                            :options="availableProducts"
                            v-model="newItem.product"
                            scope="addItemForm"
                            validation="required"></select-field>
            </div>
            <div class="col-sm-4">
              <text-field
                field-id="addItemForm.price"
                label="Cena (€)"
                v-model="newItem.price"
                scope="addItemForm"
                :maxlength="20"
                validation="required|decimal2:2|min_value2:0.01"></text-field>
            </div>
            <div class="col-sm-2">
              <button @click.prevent="addItem()" class="btn btn-success btn-input-line" type="button" title="Pridať"><i class="fa fa-plus"></i></button>
            </div>
          </div>
        </form>

        <div class="row" v-if="priceList.items.length">
          <div class="col-sm-12">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Produkt</th>
                  <th>Cena</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
              <template v-for="item in priceList.items">
                <tr>
                  <td class="col-md-8">{{ item.product.label }}</td>
                  <td class="col-md-2">{{ item.price | currency }}</td>
                  <td class="col-md-2 text-right"><button class="btn btn-xs btn-link" @click.prevent="deleteItem(item)"><i class="fa fa-2x fa-times text-danger" title="Zmazať"></i></button></td>
                </tr>
              </template>
              </tbody>
            </table>

          </div>
        </div>
        <div v-else class="row">
          <div class="col-md-12">
            <alert type="warning">Nebola pridaná žiadna položka cenníku.</alert>
          </div>
        </div>

    </modalWindow>
  </div>
</template>

<script>
  import modal from 'vue-strap/src/Modal';
  import {alert} from 'vue-strap';
  import { mapState } from 'vuex';
  import _ from 'lodash';
  import validationMixin from 'components/validationMixin';
  import notificationService from 'services/notificationService';
  import dateField from 'components/form/dateField';
  import selectField from 'components/form/selectField';
  import numberField from 'components/form/numberField';
  import textField from 'components/form/textField';

  export default {
    components: {modalWindow: modal, alert, selectField, dateField, numberField, textField},
    mixins: [validationMixin],
    data: () => ({
      show: false,
      price: null,
      priceList: null,
      newItem: {
        product: null,
        price: null
      }
    }),
    props: {
      showModel: {
        type: Boolean,
        default () {
          return false;
        }
      },
      model: {
        type: Object
      }
    },
    computed: {
      ...mapState({
        customers: (state, getters) => getters['customer/activeItems'],
        availableProducts (state, getters) {
          const alreadyAddedProductIds = _.map(this.priceList.items, 'product.id');
          return _(getters['product/validItems'])
            .filter(item => alreadyAddedProductIds.indexOf(item.id) < 0)
            .value();
        }
      })
    },
    methods: {
      cancel() {
        this.$emit('close');
      },
      editMode() {
        return !!(this.priceList && this.priceList.id);
      },
      addItem() {
        this.$validator.validateAll('addItemForm').then((res) => {
          if (res) {
            this.priceList.items.push({
              product: this.newItem.product,
              price: parseFloat(this.newItem.price.replace(',','.'))
            });
            this.newItem.product = null;
            this.newItem.price = null;
          }
        });
      },
      deleteItem(itemToDelete) {
        this.priceList.items = _.filter(this.priceList.items, (item) => item.product.id !== itemToDelete.product.id);
      },
      async createSubmit() {
        if (this.priceList.validFrom && this.priceList.validTo) {
          if (this.priceList.validFrom.isAfter(this.priceList.validFrom)) {
            return notificationService.error('error.pricelist.date.invalid');
          }
        } else if (!this.priceList.items.length) {
          return notificationService.error('V cenníku nie je žiadna položka.');
        }

        await this.protect();
        this.$validator.validateAll('createForm').then((res) => {

          if (res) {
            let operation;
            if (this.priceList.id) {
              operation = 'priceList/update';
            } else {
              operation = 'priceList/create';
            }
            const priceList = _.cloneDeep(this.priceList);

            this.$store.dispatch(operation, priceList).then((result) => {
              if (result) {
                notificationService.success('Cenník bol uložený.');
                this.$emit('close');
              } else {
                this.unprotect();
              }
            }).catch(this.unprotect);
          } else {
            this.unprotect();
          }
        }).catch(this.unprotect);
      },
      clear() {
        this.newItem.product = null;
        this.newItem.price = null;
        this.unprotect();
        this.$nextTick(() => {
          this.errors.clear('createForm');
          this.errors.clear('addItemForm');
        });
      },
      onClose() {
        this.clear();
      }
    },
    watch: {
      model (model) {
        this.priceList = _.cloneDeep(model);
      },
      showModel(showModel) {
        this.show = showModel;
      }
    },
    created () {
      this.$store.dispatch('customer/getAll');
      this.$store.dispatch('product/getAll');
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/priceListCreateModal.vue